const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-86358427-f433-44b2-a5fd-a2c6ecb21fcd {\n        fill: #5e3524;\n      }\n\n      .uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d {\n        stroke-linecap: round;\n      }\n\n      .uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d, .uuid-cfd3126c-ab92-4f4d-b519-20965e9cb7b4, .uuid-d9b55bb5-0274-432d-8274-2fb91721f090 {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-d9b55bb5-0274-432d-8274-2fb91721f090 {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-4e3ceed2-4556-4690-8237-3d9c9a73064c",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-86358427-f433-44b2-a5fd-a2c6ecb21fcd",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-ac68b525-e0ed-4c2b-93cb-f09dc909d632",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-d9b55bb5-0274-432d-8274-2fb91721f090",
  d: "M9.72,12.32c1.12.34,5.94,1.61,10.24,0,.1-.04.2,0,.23.11.46,1.66,4.35,14.5,14.53,14.5,3.5,0,4.13,4.79,0,4.68H10.41s-1.93.2-2.57-2c-.23-.78-.2-1.61-.02-2.4.51-2.21,1.89-8.79,1.67-14.71,0-.12.11-.21.23-.18Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-cfd3126c-ab92-4f4d-b519-20965e9cb7b4",
  x1: 7.84,
  y1: 29.23,
  x2: 37.58,
  y2: 29.23
}), /*#__PURE__*/React.createElement("circle", {
  className: "uuid-cfd3126c-ab92-4f4d-b519-20965e9cb7b4",
  cx: 14.19,
  cy: 18.55,
  r: 1.91
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d",
  x1: 21.51,
  y1: 16.06,
  x2: 19.54,
  y2: 17.59
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d",
  x1: 22.74,
  y1: 18.55,
  x2: 21.09,
  y2: 19.93
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d",
  x1: 24.27,
  y1: 20.95,
  x2: 22.63,
  y2: 22.29
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d",
  x1: 25.88,
  y1: 22.89,
  x2: 24.41,
  y2: 24.23
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d",
  x1: 27.88,
  y1: 24.69,
  x2: 26.66,
  y2: 25.97
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b55003b3-0f08-45b7-9955-c79a1de77d5d",
  x1: 30.15,
  y1: 25.97,
  x2: 29.11,
  y2: 27.38
}));
function SvgRepozeIconCategoryShoes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryShoes);
export default __webpack_public_path__ + "static/media/repoze_icon_category-shoes.5132eaf6993da0ceaa2e2d4225c4afce.svg";
export { ForwardRef as ReactComponent };